<app-timing-item-display *ngFor="let item of timingObject.Timings; let even=even" 
    [timingItem]="item" 
    [startTimeStamp]="getStartTimeStamp()" 
    [flatTimings]="flatTimings"
    [depth]="depth" 
    [alt]="useEven(even)"
    [classLevels]="classLevels"
    [collapseState]="collapseState">
</app-timing-item-display>